<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>
  {{ type === 'delivered' ? 'Link alla consegna consegnato' : type === 'paymentlink' ? 'Payment Link' : 'Link alla consegna' }}
</h1>
<div mat-dialog-content>
  <input #linkInput type="text" readonly [value]="link" (click)="copyLink(linkInput)">
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button mat-dialog-close class="btn" (click)="copyLink(linkInput)">
      COPIA
    </button>
  </div>
</div>
